import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { authorsActions, confirmActions, messageActions } from '../../actions'
import { format } from '../../utils'
import TablePagination from '@material-ui/core/TablePagination'
import jwt_decode from 'jwt-decode'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }
  componentWillUpdate(newProps) {
    const { pagination, order, fetchAuthors, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchAuthors({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }
  componentDidMount() {
    const { fetchAuthors } = this.props
    fetchAuthors()
  }
  renderActions = item => {
    const { fetchAuthor, deleteAuthor, addConfirm, token, restoreAuthor } = this.props

    return (
      <Fragment>
        {readOnly('autores', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchAuthor(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('autores', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste autor?',
                confirmFunction: () => {
                  restoreAuthor(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('autores', token).editar && (
              <IconButton
                onClick={() => {
                  fetchAuthor(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('autores', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste autor?',
                    confirmFunction: () => {
                      deleteAuthor(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const {
      classes,
      authors = [],
      loadingAuthors,
      addConfirm,
      restoreAuthor,
      pagination,
      order = {}
    } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingAuthors && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome completo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'documento'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('documento')
                  }}
                >
                  CPF
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'email'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('email')
                  }}
                >
                  E-mail
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(authors || []).length ? (
              (authors || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{content.nome || '--'}</TableRowColumn>
                    <TableRowColumn>{format.cpfCnpj(content.documento) || '--'}</TableRowColumn>
                    <TableRowColumn>{content.email || '--'}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingAuthors ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    author: state.authors.author,
    authors: state.authors.authors,
    loadingAuthors: state.authors.loadingAuthors,
    token: state.auth.token,
    pagination: state.authors.authorsPagination,
    order: state.authors.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(authorsActions.openModal())
    },
    closeModal: () => {
      dispatch(authorsActions.closeModal())
    },
    fetchAuthor: id => {
      dispatch(authorsActions.fetchAuthor(id))
    },
    fetchAuthors: options => {
      dispatch(authorsActions.fetchAuthors(options))
    },
    deleteAuthor: id => {
      dispatch(authorsActions.deleteAuthor(id))
    },
    handleChangePage: page => {
      dispatch(authorsActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(authorsActions.handleChangePerPage(perPage))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreAuthor: id => {
      dispatch(authorsActions.restoreAuthor(id))
    },
    changeOrderColumn: column => {
      dispatch(authorsActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(authorsActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Authors/ListTable.js